import request from './axios'
export function projectList(params, contractTotalPriceMin, contractTotalPriceMax, deviceSignedPriceMin, deviceSignedPriceMax, projectSignedPriceMin, projectSignedPriceMax, straightRaisedHighMin, straightRaisedHighMax, escalatorsRaisedHighMin, escalatorsRaisedHighMax, type) {
  return request({
    url: `/lx/api/performance/list?contractTotalPriceMin=${contractTotalPriceMin}&contractTotalPriceMax=${contractTotalPriceMax}&deviceSignedPriceMin=${deviceSignedPriceMin}&deviceSignedPriceMax=${deviceSignedPriceMax}&projectSignedPriceMin=${projectSignedPriceMin}&projectSignedPriceMax=${projectSignedPriceMax}&straightRaisedHighMin=${straightRaisedHighMin}&straightRaisedHighMax=${straightRaisedHighMax}&escalatorsRaisedHighMin=${escalatorsRaisedHighMin}&escalatorsRaisedHighMax=${escalatorsRaisedHighMax}&type=${type}`,
    method: 'get',
    params
  })
}
export function projectExport(params, contractTotalPriceMin, contractTotalPriceMax, deviceSignedPriceMin, deviceSignedPriceMax, projectSignedPriceMin, projectSignedPriceMax, straightRaisedHighMin, straightRaisedHighMax, escalatorsRaisedHighMin, escalatorsRaisedHighMax, type) {
  return request({
    url: `/lx/api/performance/list?&contractTotalPriceMin=${contractTotalPriceMin}&contractTotalPriceMax=${contractTotalPriceMax}&deviceSignedPriceMin=${deviceSignedPriceMin}&deviceSignedPriceMax=${deviceSignedPriceMax}&projectSignedPriceMin=${projectSignedPriceMin}&projectSignedPriceMax=${projectSignedPriceMax}&straightRaisedHighMin=${straightRaisedHighMin}&straightRaisedHighMax=${straightRaisedHighMax}&escalatorsRaisedHighMin=${escalatorsRaisedHighMin}&escalatorsRaisedHighMax=${escalatorsRaisedHighMax}&type=${type}`,
    method: 'get',
    responseType: 'blob',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
    params
  })
}
// 总部项目档案
export function pDetailsList(params) {
  return request({
    url: `/lx/project/publish-files/list`,
    method: 'get',
    params
  })
}
// 总部项目信息
export function detailsList(id) {
  return request({
    url: `/lx/project/importProject/info/${id}`,
    method: 'get'
  })
}
// 删除项目
export function detailsDelete(id) {
  return request({
    url: `/lx/api/business/${id}`,
    method: 'DELETE'
  })
}
// 删除项目
export function projectDelete(id) {
  return request({
    url: `/lx/api/document/task/deleteById?id=${id}`,
    method: 'post'
  })
}
// 删除素材
export function deteleTypeData(id, type, bid) {
  return request({
    url: `/lx/project/personalOfficefile/deleMaterial?id=${id}&type=${type}&bid=${bid}`,
    method: 'post'
  })
}
// 编辑文档保存素材
export function testSave(taskId) {
  return request({
    url: `/lx/fodder/getSaveFooder?taskId=${taskId}`,
    method: 'post'
  })
}
